// import ReduxThunk from 'redux-thunk';
// import { createStore, applyMiddleware} from 'redux';

// import adminReducer  from './reducers/index';

// const createStoreMiddleStore= applyMiddleware(ReduxThunk)(createStore);
// export const adminStore= createStoreMiddleStore(adminReducer);

import { createStore, compose, applyMiddleware } from "redux";
import { createLogger } from "redux-logger";
import immutableCheckMiddleWare from "redux-immutable-state-invariant";
import thunk from "redux-thunk";
import adminReducer from "./reducers/index";

const middleWare = [];
middleWare.push(thunk);

if (process.env.NODE_ENV === "development") {
  middleWare.push(immutableCheckMiddleWare());
}

const loggerMiddleware = createLogger({
  predicate: () => process.env.NODE_ENV === "development",
});

middleWare.push(loggerMiddleware);

const adminStore = createStore(
  adminReducer,
  {},
  compose(
    applyMiddleware(...middleWare),
    window.devToolsExtension ? window.devToolsExtension() : (f) => f
  )
);

export default adminStore;
